<template>
  <footer class="footer">
    <div class="container">
      <!-- <p class="copyright">© {{ currentYear }} by All Asian Massage 6. Proudly created by www.yiz-net.com</p> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style scoped>
.footer {
  background-color: var(--dark-bg-color);
  color: #fff;
  padding: 1rem 0;
  text-align: center;
  margin-top: 2rem;
}

.copyright {
  font-size: 0.9rem;
  margin: 0;
}
</style>
